module.exports = __webpack_public_path__ + "img/learning.f5095369.svg";